// src/app/pages/auth/KycPendingPage.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Clock, Mail, ShieldCheck, AlertCircle } from "lucide-react";

export default function KycPendingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Check KYC status periodically
    const interval = setInterval(() => {
      // TODO: Add API call to check KYC status
      // If approved, redirect to dashboard
      // If rejected, redirect to KYC page with rejection reason
    }, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-indigo-900 to-purple-900 px-4 py-10">
      <div className="w-full max-w-md text-center">
        <div className="relative inline-block mb-6">
          <div className="h-24 w-24 rounded-full bg-gradient-to-r from-primary-600 to-cyan-600 flex items-center justify-center animate-pulse">
            <Clock size={32} className="text-white" />
          </div>
          <div className="absolute -top-2 -right-2 h-10 w-10 rounded-full bg-amber-500 flex items-center justify-center animate-bounce">
            <AlertCircle size={20} className="text-white" />
          </div>
        </div>

        <h1 className="text-3xl font-bold text-white mb-4">Verification in Progress</h1>
        
        <div className="space-y-4 mb-8">
          <div className="text-gray-300">
            Your KYC documents have been successfully submitted and are under review.
          </div>
          
          <div className="bg-gray-900/40 border border-gray-800 rounded-2xl p-5">
            <div className="flex items-center gap-3 mb-3">
              <Mail size={20} className="text-primary-400" />
              <h3 className="font-semibold text-white">What happens next?</h3>
            </div>
            <ul className="text-left space-y-2 text-sm text-gray-400">
              <li className="flex items-start gap-2">
                <ShieldCheck size={16} className="text-emerald-400 mt-0.5 flex-shrink-0" />
                <span>Our compliance team will review your documents (24-48 hours)</span>
              </li>
              <li className="flex items-start gap-2">
                <ShieldCheck size={16} className="text-emerald-400 mt-0.5 flex-shrink-0" />
                <span>You'll receive an email notification once approved</span>
              </li>
              <li className="flex items-start gap-2">
                <ShieldCheck size={16} className="text-emerald-400 mt-0.5 flex-shrink-0" />
                <span>If additional information is needed, we'll contact you</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-sm text-gray-500 space-y-2">
          <p>Please check your email for updates.</p>
          <p>
            Need help?{" "}
            <a href="mailto:admin@worldcoinscom.com" className="text-primary-400 hover:text-primary-300">
              Contact our support team
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
